module.exports = __webpack_public_path__ + "img/mining-productivity.085871df.png";